import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import schemaSettings from '../../../shared/schemas/location-vehicle-shift-schema'
const { locationVehicleShiftSchema: schema } = schemaSettings
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'

const service = apiClient.service('location-vehicle-shifts')

export default ({ name, app }) => {
  app.on('initialized', () => {
    const updateEntities = app.getSequence('locationVehicleShifts.updateEntities')
    service.on('patched', (shift) => updateEntities({ entities: { locationVehicleShifts: [shift] } }))
  })

  return {
    state: {
      ...createCrudState({ entityType: 'locationVehicleShifts', storePrefix: name }),
    },
    sequences,
    providers: createProviders({ name, service, schema }),
    catch: [
      redirectUnauthorized(),
      [
        Error,
        showFeedbackFromError({ title: 'We encountered an error' }),
        ({ props: { error, errorPath = name }, store }) => {
          store.set(state`errors.${errorPath}`, error)
        },
      ],
    ],
  }
}
